export const Pickup = () => {
	return (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="24"
				height="24"
				rx="4"
				transform="matrix(1 0 0 -1 0.5 24)"
				fill="#FFB352"
			/>
			<path
				d="M11.4619 3.98242C12.0115 3.33976 12.9885 3.33976 13.5381 3.98242L19.2676 10.6826C19.7723 11.2728 19.4036 12.2683 18.5596 12.2686H16.8994C16.2219 12.2686 15.6399 12.8454 15.6396 13.5977V16.3418C15.6396 17.1046 15.0399 17.7558 14.2598 17.7559H10.7402C9.96014 17.7558 9.36037 17.1046 9.36035 16.3418V13.5977C9.36012 12.8454 8.77812 12.2686 8.10059 12.2686H6.44043C5.5964 12.2683 5.22768 11.2728 5.73242 10.6826L11.4619 3.98242Z"
				fill="#FFB352"
				stroke="#454545"
				strokeLinecap="round"
			/>
		</svg>
	);
};
